import { render, staticRenderFns } from "./refIndex.vue?vue&type=template&id=ee24bd7e"
import script from "./refIndex.vue?vue&type=script&lang=js"
export * from "./refIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports